import { CombinedStateCreator } from "../store";

export interface ChatStore {
  chatDrafts: Record<string, string>;
  setChatDraft: (conversationId: string, draft: string) => void;
  clearChatDraft: (conversationId: string) => void;
}

export const createChatStore: CombinedStateCreator<ChatStore> = (set) => ({
  chatDrafts: {},
  setChatDraft: (conversationId, draft) =>
    set((state) => {
      state.chatDrafts[conversationId] = draft;
    }),
  clearChatDraft: (conversationId) =>
    set((state) => {
      delete state.chatDrafts[conversationId];
    }),
});
